import { axios } from '@/libs/api.request';
import { Params } from '@/libs/types';
import { Response } from '@/types/request.d';
import { AxiosRequestConfig } from 'axios';
import { Cache } from '@/libs/cache';

export const changeAxiosUrl = (baseUrl: string) => {
    if (!baseUrl) { return; }
    axios.baseUrl = baseUrl;
};

export const getGlobalVal = (key: string) => axios.request({
    url: 'sys/config/global-val/get-val',
    method: 'get',
    params: {
        key,
    },
});

// 通过手机或者邮件重置密码时的页面需要调用这个接口检查token是否合法
export const pageVerify = ({
    token,
    type,
}: Params) => axios.request({
    url: 'sys/config/page-verify/verify',
    method: 'get',
    params: {
        token,
        type,
    },
});

// 国家列表接口(country_code_two,cn_name,en_name)
export const getCountryList = (fields: string) => axios.request({
    url: 'sys/config/country/get-list',
    method: 'get',
    params: {
        fields: fields || '',
    },
});

export const getVisitorIp = () => axios.request({
    url: 'sys/config/ip/get-visitor-ip',
    method: 'get',
});

export const getVersion = () => {
    const host = window.location.origin;
    return axios.request({
        url: `${host}/version.json?_t=${new Date().getTime()}`,
        method: 'get',
    });
};

export const getGlobalCountryList = () => axios.request({
    url: 'sys/config/global-val/country-list',
    method: 'get',
});

interface RegionByIPRes {
    ip_data: {
        country: string;
    };
}
export const getRegionByIP = (baseURL?: string) => {
    const config: any = {
        url: 'sys/config/ip/get-visitor-ip',
        method: 'get',
        customTips: true,
    };
    if (baseURL) {
        config.baseURL = baseURL;
    }
    return axios.request<Response<RegionByIPRes>>(config);
};

export const VISITOR_IP_KEY = 'SYS_VISITOR_IP';
export const VISITOR_IP_KEY_GLOBAL = 'SYS_VISITOR_IP_GLOBAL';
export const getVisitorIpByStorage = async (useGlobal: boolean = false, useLocal: boolean = true) => {
    // 两分钟缓存，避免频繁刷新
    const localKey = useGlobal ? VISITOR_IP_KEY_GLOBAL : VISITOR_IP_KEY;
    const timestamp = 60 * 1000 * 2;
    if (useLocal) {
        const result: any = await Cache.getItem(localKey);
        if (result) {
            const visitorIPObj = result || {};
            if (new Date().getTime() - visitorIPObj.timestamp < timestamp) {
                return visitorIPObj.result;
            }
        }
    }
    let res;
    try {
        // global域名
        const baseURL = useGlobal ? 'https://api-global.salesmartly.com/' : '';
        res = await getRegionByIP(baseURL).then();
        const data = {
            timestamp: new Date().getTime(),
            result: res,
        };
        Cache.setItem(localKey, data);
    } catch (e) {
        console.log(e);
        return Promise.reject(e);
    }
    return res;
};

export type PayType =
    'shopify_pay' |
    'cmbpay' |
    'wechat' |
    'alipay' |
    'stripe_card' |
    'paypal' |
    'epay_usdt' |
    'coinify_usdt' |
    'coinify_eth' |
    'coinify_btc' |
    'coinify_usdc' |
    'riat_usdt' |
    'pyvio_usdt' |
    'triplea_usdt' |
    'triplea_btc' |
    'triplea_eth' |
    'triplea_usdc' |
    'stripe_v2' |
    'corporate_transfer' |
    'fypayvnd';

/**
 * 获取支付方式列表
 */
export const getPayType = () => axios.request<Response<PayType[]>>({
    url: '/sys/project/order/get-pay-type',
    method: 'get',
    params: { pay_version: 'V2' },
});
